import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { useDestroyAuditReportUser, useUpdateAuditReportUser } from 'api/hooks/use-audit-report-user'
import { useQueryClient } from 'react-query'
import MutedText from 'shared/forms/muted-text'

function UserRow({ auditReportUser, editable }) {
  const queryClient = useQueryClient()
  const [isEditor, setIsEditor] = useState(auditReportUser.is_editor || false)

  const invalidate = () => {
    queryClient.invalidateQueries(`reports/${auditReportUser.audit_report_id}`)
    queryClient.invalidateQueries('reports')
  }

  const { mutate: destroyMutation, isLoading: isDestroying } = useDestroyAuditReportUser({
    id: auditReportUser.id,
    options: { onSuccess: invalidate }
  })

  const { mutate: updateMutation, isLoading: isUpdating } = useUpdateAuditReportUser({
    id: auditReportUser.id,
    options: {
      onSuccess: (data) => {
        if (data && data.is_editor !== undefined) {
          setIsEditor(data.is_editor)
        }
        invalidate()
      }
    }
  })

  const handleRoleChange = (e) => {
    updateMutation({ is_editor: e.target.value === 'editor' })
  }

  return (
    <tr>
      <td>
        <div className="d-flex align-items-center justify-content-between gap-2">
          <div>
            {auditReportUser.first_name} {auditReportUser.last_name}
            <MutedText as="div">
              <small>{auditReportUser.email}</small>
            </MutedText>
          </div>
          {editable && (
            <Form.Select
              size="sm"
              id={`report-editor-select-${auditReportUser.id}`}
              aria-label="Access role"
              value={isEditor ? 'editor' : 'viewer'}
              onChange={handleRoleChange}
              disabled={isUpdating || isDestroying}
              style={{ width: 'auto' }}
            >
              <option value="viewer">Viewer</option>
              <option value="editor">Editor</option>
            </Form.Select>
          )}
        </div>
      </td>
      <td className="align-middle text-end">
        {editable && (
          <Button
            variant="light"
            className="bg-light"
            onClick={() => destroyMutation()}
            disabled={isDestroying || isUpdating}
          >
            <FontAwesomeIcon icon={faTrash} className="text-danger" />
          </Button>
        )}
      </td>
    </tr>
  )
}

export default UserRow
